(function (Drupal) {
  Drupal.behaviors.brazePlacementId = {
    attach: function (context, drupalSettings) {
      brazeData.then(() => {

        braze.requestBannersRefresh([drupalSettings.braze_placement_id.placement_id])

        const time = setInterval(() => {
          const globalBanner = braze.getBanner(drupalSettings.braze_placement_id.placement_id);
          if (globalBanner) {
            clearInterval(time);
            const container = document.getElementById("braze-placement-id-container");

            braze.insertBanner(globalBanner, container);

            if (globalBanner.isControl) {
              container.style.display = "none";
            }
          }
        }, 500);
      })
    }
  };
})(Drupal);